module.exports = __webpack_public_path__ + "static/media/mrpaycard-bg.09ac6c28.jpg";